import React, { useState } from "react";
import ProfileBusiness from "./ProfileBusiness";


import Security        from "./Security";

const API = "https://canada-billing.ameontech.com";

const SETTINGS_STYLES = `
  .st-wrap { display: flex; flex-direction: column; gap: 0; max-width: 900px; }

  /* ── Tab Bar ── */
  .st-tabs {
    display: flex; gap: 4px;
    background: #fff; border: 1px solid #f0f0f0;
    border-radius: 14px 14px 0 0; padding: 10px 14px 0;
    border-bottom: none; flex-wrap: wrap;
  }
  .st-tab {
    display: flex; align-items: center; gap: 7px;
    padding: 9px 16px; border-radius: 9px 9px 0 0;
    font-size: 12px; font-weight: 600;
    font-family: 'DM Sans', sans-serif;
    color: #888; background: transparent;
    border: none; cursor: pointer;
    border-bottom: 2px solid transparent;
    transition: all .15s; white-space: nowrap;
  }
  .st-tab:hover { color: #1a1a2e; background: #f8fafc; }
  .st-tab.active { color: #4f8ef7; border-bottom: 2px solid #4f8ef7; background: #eff6ff; }
  .st-tab-icon { font-size: 15px; }

  /* ── Card ── */
  .st-card {
    background: #fff; border: 1px solid #f0f0f0;
    border-radius: 0 0 14px 14px; overflow: hidden;
  }
  .st-card-hdr {
    padding: 18px 24px 16px; border-bottom: 1px solid #f5f5f5;
    display: flex; align-items: center; gap: 12px; background: #fafbff;
  }
  .st-card-hdr-icon {
    width: 38px; height: 38px; border-radius: 10px;
    display: flex; align-items: center; justify-content: center;
    font-size: 18px; flex-shrink: 0;
  }
  .st-card-hdr-title {
    font-family: 'Playfair Display', serif;
    font-size: 15px; font-weight: 700; color: #1a1a2e;
  }
  .st-card-hdr-sub { font-size: 11px; color: #888; margin-top: 2px; }
  .st-card-body { padding: 22px 24px; display: flex; flex-direction: column; gap: 18px; }

  /* ── Row ── */
  .st-row {
    display: flex; align-items: center; justify-content: space-between;
    gap: 16px; flex-wrap: wrap;
  }
  .st-row-label { font-size: 13px; font-weight: 600; color: #1a1a2e; }
  .st-row-sub { font-size: 11px; color: #888; margin-top: 2px; }

  /* ── Inputs ── */
  .st-input {
    padding: 9px 13px; border: 1.5px solid #f0f0f0;
    border-radius: 9px; font-size: 13px; font-family: 'DM Sans', sans-serif;
    color: #1a1a2e; background: #fafafa;
    transition: border-color .15s, background .15s;
    min-width: 220px; outline: none;
  }
  .st-input:focus { border-color: #4f8ef7; background: #fff; }

  .st-select {
    padding: 9px 13px; border: 1.5px solid #f0f0f0;
    border-radius: 9px; font-size: 13px; font-family: 'DM Sans', sans-serif;
    color: #1a1a2e; background: #fafafa;
    transition: border-color .15s; min-width: 180px; outline: none; cursor: pointer;
  }
  .st-select:focus { border-color: #4f8ef7; background: #fff; }

  .st-divider { height: 1px; background: #f5f5f5; margin: 2px 0; }

  /* ── Toggle ── */
  .st-toggle {
    width: 40px; height: 22px; border-radius: 11px;
    background: #e8e8e8; position: relative;
    transition: background .2s; flex-shrink: 0; cursor: pointer;
    border: none; outline: none;
  }
  .st-toggle.on { background: linear-gradient(135deg, #4f8ef7, #6366f1); }
  .st-toggle::after {
    content: ''; position: absolute;
    width: 16px; height: 16px; border-radius: 50%;
    background: #fff; top: 3px; left: 3px;
    transition: transform .2s; box-shadow: 0 1px 4px rgba(0,0,0,.15);
  }
  .st-toggle.on::after { transform: translateX(18px); }

  /* ── Avatar ── */
  .st-avatar-wrap { display: flex; align-items: center; gap: 14px; }
  .st-avatar {
    width: 52px; height: 52px; border-radius: 13px;
    background: linear-gradient(135deg, #4f8ef7, #6366f1);
    color: #fff; display: flex; align-items: center; justify-content: center;
    font-size: 20px; font-weight: 700; flex-shrink: 0;
  }
  .st-avatar-btn {
    padding: 7px 14px; border-radius: 50px;
    border: 1.5px solid #f0f0f0; background: transparent;
    font-size: 12px; font-weight: 600; color: #555;
    font-family: 'DM Sans', sans-serif; cursor: pointer; transition: all .15s;
  }
  .st-avatar-btn:hover { border-color: #4f8ef7; color: #4f8ef7; background: #eff6ff; }

  /* ── Bank ── */
  .st-bank-note {
    display: flex; align-items: flex-start; gap: 10px;
    background: rgba(79,142,247,.06); border: 1px solid rgba(79,142,247,.18);
    border-radius: 10px; padding: 12px 14px;
    font-size: 12px; color: #4f8ef7; font-weight: 500;
  }
  .st-compliance-badge {
    display: inline-flex; align-items: center; gap: 6px;
    background: rgba(82,201,126,.1); border: 1px solid rgba(82,201,126,.25);
    color: #52c97e; border-radius: 20px; padding: 4px 12px;
    font-size: 11px; font-weight: 600;
  }
  .st-primary-badge {
    display: inline-flex; align-items: center; gap: 5px;
    background: rgba(79,142,247,.1); color: #4f8ef7;
    border-radius: 20px; padding: 4px 12px;
    font-size: 11px; font-weight: 600;
  }

  /* ── Buttons ── */
  .st-save-row {
    display: flex; justify-content: flex-end;
    padding: 16px 24px; border-top: 1px solid #f5f5f5;
  }
  .st-save-btn {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 9px 22px; border-radius: 50px;
    background: linear-gradient(135deg, #4f8ef7, #6366f1);
    color: #fff; font-size: 13px; font-weight: 600;
    font-family: 'DM Sans', sans-serif; border: none; cursor: pointer;
    transition: opacity .15s;
  }
  .st-save-btn:hover { opacity: .88; }
  .st-save-btn:disabled { opacity: .55; cursor: not-allowed; }

  .st-danger-btn {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 8px 18px; border-radius: 50px;
    background: transparent; border: 1.5px solid rgba(249,123,107,.4);
    color: #f97b6b; font-size: 12px; font-weight: 600;
    font-family: 'DM Sans', sans-serif; cursor: pointer; transition: all .15s;
  }
  .st-danger-btn:hover { background: rgba(249,123,107,.08); border-color: #f97b6b; }

  .st-badge {
    display: inline-flex; align-items: center; gap: 5px;
    padding: 4px 10px; border-radius: 20px; font-size: 11px; font-weight: 600;
  }
  .st-badge-green { background: rgba(82,201,126,.1); color: #52c97e; }

  /* ── Toast ── */
  .st-saved-toast {
    position: fixed; bottom: 24px; right: 24px; z-index: 9999;
    background: #13131f; border: 1px solid rgba(255,255,255,.1);
    border-left: 3px solid #52c97e; border-radius: 12px;
    padding: 13px 18px; display: flex; align-items: center; gap: 10px;
    font-size: 13px; font-weight: 500; color: #fff;
    box-shadow: 0 8px 32px rgba(0,0,0,.25);
    animation: stSlideIn .3s ease;
  }
  @keyframes stSlideIn {
    from { transform: translateX(40px); opacity: 0; }
    to   { transform: translateX(0);    opacity: 1; }
  }
`;

const TABS = [
  { id: "profile",       label: "Profile & Business", icon: "👤" },
 
  { id: "security",      label: "Security",           icon: "🔒" },
];

export default function Settings() {
  const [activeTab, setActiveTab] = useState("profile");
  const [saving,    setSaving]    = useState(false);
  const [saved,     setSaved]     = useState(false);
  const [saveError, setSaveError] = useState("");

  const [profile, setProfile] = useState({
    name: "Admin", email: "admin@invoicecloud.ca",
    phone: "+1 (647) 000-0000", company: "InvoiceCloud Canada",
    businessNumber: "", hstNumber: "", naicsCode: "",
    addressLine1: "", addressLine2: "", city: "Toronto",
    province: "ON", postalCode: "", website: "",
    country: "Canada", currency: "CAD", dateFormat: "MM/DD/YYYY",
    autoRound: false, taxInclusive: false,
    invoicePrefix: "INV", invoiceStartNumber: "1",
    dueDays: "30", footerNote: "", terms: "",
  });

  const [regional, setRegional] = useState({
    currency: "CAD", dateFormat: "MM/DD/YYYY",
    taxRate: "13", fiscalYearStart: "January",
    autoRound: false, taxInclusive: false,
  });

  const [notif, setNotif] = useState({
    invoiceReminders: true, paymentReceived: true,
    overdueAlerts: true, weeklyReport: false, emailNotif: true,
  });

  const [bank, setBank] = useState({
    bankName: "", accountHolderName: "", accountType: "Chequing",
    accountNumber: "", transitNumber: "", institutionNumber: "",
    interacEmail: "", branchLocation: "", isPrimary: true, isActive: true,
  });

  const [twoFA, setTwoFA] = useState(false);

  // ── Real Save ──
  const handleSave = async () => {
    setSaving(true);
    setSaveError("");
    try {
      const token   = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      const [profileRes, userRes] = await Promise.all([
        fetch(`${API}/api/business-profile`, {
          method: "POST",
          headers: { ...headers, "Content-Type": "application/json" },
          body: JSON.stringify({
            business_name:        profile.company            || "",
            business_type:        profile.businessType       || "",
            email:                profile.email              || "",
            phone:                profile.phone              || "",
            website:              profile.website            || "",
            business_number:      profile.businessNumber     || "",
            hst_number:           profile.hstNumber          || "",
            naics_code:           profile.naicsCode          || "",
            address_line1:        profile.addressLine1       || "",
            address_line2:        profile.addressLine2       || "",
            city:                 profile.city               || "",
            province:             profile.province           || "ON",
            postal_code:          profile.postalCode         || "",
            country:              profile.country            || "Canada",
            currency:             profile.currency           || "CAD",
            date_format:          profile.dateFormat         || "MM/DD/YYYY",
            auto_round:           profile.autoRound          || false,
            tax_inclusive:        profile.taxInclusive       || false,
            invoice_prefix:       profile.invoicePrefix      || "INV",
            invoice_start_number: profile.invoiceStartNumber || 1,
            due_days:             profile.dueDays            || 30,
            footer_note:          profile.footerNote         || "",
            terms:                profile.terms              || "",
          }),
        }),
        fetch(`${API}/api/user/me`, {
          method: "PUT",
          headers: { ...headers, "Content-Type": "application/json" },
          body: JSON.stringify({
            full_name: profile.name  || "",
            email:     profile.email || "",
          }),
        }),
      ]);

      const profileData = await profileRes.json();
      const userData    = await userRes.json();
      if (!profileRes.ok) throw new Error(profileData.message);
      if (!userRes.ok)    throw new Error(userData.message);

      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (err) {
      setSaveError("❌ " + err.message);
      setTimeout(() => setSaveError(""), 4000);
    } finally {
      setSaving(false);
    }
  };

  const renderTab = () => {
    switch (activeTab) {
      case "profile":       return <ProfileBusiness profile={profile} setProfile={setProfile} />;
      
      case "security":      return <Security twoFA={twoFA} setTwoFA={setTwoFA} />;
      default:              return null;
    }
  };

  return (
    <>
      <style>{SETTINGS_STYLES}</style>
      <div className="st-wrap">
        <div className="st-tabs">
          {TABS.map(t => (
            <button
              key={t.id}
              className={`st-tab${activeTab === t.id ? " active" : ""}`}
              onClick={() => setActiveTab(t.id)}
            >
              <span className="st-tab-icon">{t.icon}</span>
              {t.label}
            </button>
          ))}
        </div>
        <div className="st-card">
          {renderTab()}
          <div className="st-save-row">
            <button className="st-save-btn" onClick={handleSave} disabled={saving}>
              {saving ? "Saving…" : "✓ Save Settings"}
            </button>
          </div>
        </div>
      </div>

      {saved && (
        <div className="st-saved-toast">✓ Settings saved successfully</div>
      )}
      {saveError && (
        <div className="st-saved-toast" style={{ borderLeftColor: "#f97b6b" }}>
          {saveError}
        </div>
      )}
    </>
  );
}